module.exports = __webpack_public_path__ + "img/ic-stripe.94fc25ae.png";